// REDUX ACTION TYPES
export const DARK_MODE = 'DARK_MODE'
export const THEME = 'THEME'
export const LOGIN = 'LOGIN'
export const SET_LOADER = 'SET_LOADER'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_UNIT = 'SET_UNIT'
